import { productColorName, productColorBackground } from '../../helpers/productColor';

// A small colour dot showing a product's real (sheath / wire) colour. Pass either a
// `row` (job / bobin row — colour is derived from its productKey / color) or an
// explicit `colorName`. Renders nothing when no colour can be resolved.
const ProductColorDot = ({ row, colorName, size = 12, className = '' }) => {
  const name = colorName || productColorName(row);
  if (!name) return null;
  return (
    <span
      title={name}
      className={className}
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        background: productColorBackground(name),
        border: '1px solid rgba(120,120,120,0.55)',
        flexShrink: 0,
        verticalAlign: 'middle'
      }}
    />
  );
};

export default ProductColorDot;
